// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutUsRouteImport } from './routes/about-us'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AnimalcareRouteImport } from './routes/animalcare'
import { Route as ChaptersRouteImport } from './routes/chapters'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as CoreValuesRouteImport } from './routes/core-values'
import { Route as DonateRouteImport } from './routes/donate'
import { Route as EmployerDonationMatchingRouteImport } from './routes/employer-donation-matching'
import { Route as NewChapterRouteImport } from './routes/new-chapter'
import { Route as OpenRescueRouteImport } from './routes/open-rescue'
import { Route as PayrollGivingRouteImport } from './routes/payroll-giving'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as TakeActionRouteImport } from './routes/take-action'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as VeganismRouteImport } from './routes/veganism'
import { Route as WhistleblowerSupportRouteImport } from './routes/whistleblower-support'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as CampaignsIndexRouteImport } from './routes/campaigns/index'
import { Route as CampaignsSlugRouteImport } from './routes/campaigns/$slug'
import { Route as DxeInTheNewsSlugRouteImport } from './routes/dxe-in-the-news/$slug'
import { Route as EsWhistleblowerSupportRouteImport } from './routes/es/whistleblower-support'
import { Route as EventsIndexRouteImport } from './routes/events/index'
import { Route as EventsChaptersRouteImport } from './routes/events/chapters'
import { Route as NewsIndexRouteImport } from './routes/news/index'
import { Route as NewsTypeRouteImport } from './routes/news/$type'
import { Route as EventsPageIdIndexRouteImport } from './routes/events/$pageId/index'
import { Route as EventsPageIdEventIdRouteImport } from './routes/events/$pageId/$eventId'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutUsRoute = AboutUsRouteImport.update({
            id: '/about-us',path: '/about-us',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AnimalcareRoute = AnimalcareRouteImport.update({
            id: '/animalcare',path: '/animalcare',getParentRoute: () => rootRouteImport
          })
const ChaptersRoute = ChaptersRouteImport.update({
            id: '/chapters',path: '/chapters',getParentRoute: () => rootRouteImport
          })
const ContactUsRoute = ContactUsRouteImport.update({
            id: '/contact-us',path: '/contact-us',getParentRoute: () => rootRouteImport
          })
const CoreValuesRoute = CoreValuesRouteImport.update({
            id: '/core-values',path: '/core-values',getParentRoute: () => rootRouteImport
          })
const DonateRoute = DonateRouteImport.update({
            id: '/donate',path: '/donate',getParentRoute: () => rootRouteImport
          })
const EmployerDonationMatchingRoute = EmployerDonationMatchingRouteImport.update({
            id: '/employer-donation-matching',path: '/employer-donation-matching',getParentRoute: () => rootRouteImport
          })
const NewChapterRoute = NewChapterRouteImport.update({
            id: '/new-chapter',path: '/new-chapter',getParentRoute: () => rootRouteImport
          })
const OpenRescueRoute = OpenRescueRouteImport.update({
            id: '/open-rescue',path: '/open-rescue',getParentRoute: () => rootRouteImport
          })
const PayrollGivingRoute = PayrollGivingRouteImport.update({
            id: '/payroll-giving',path: '/payroll-giving',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const TakeActionRoute = TakeActionRouteImport.update({
            id: '/take-action',path: '/take-action',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const VeganismRoute = VeganismRouteImport.update({
            id: '/veganism',path: '/veganism',getParentRoute: () => rootRouteImport
          })
const WhistleblowerSupportRoute = WhistleblowerSupportRouteImport.update({
            id: '/whistleblower-support',path: '/whistleblower-support',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const CampaignsIndexRoute = CampaignsIndexRouteImport.update({
            id: '/campaigns/',path: '/campaigns/',getParentRoute: () => rootRouteImport
          })
const CampaignsSlugRoute = CampaignsSlugRouteImport.update({
            id: '/campaigns/$slug',path: '/campaigns/$slug',getParentRoute: () => rootRouteImport
          })
const DxeInTheNewsSlugRoute = DxeInTheNewsSlugRouteImport.update({
            id: '/dxe-in-the-news/$slug',path: '/dxe-in-the-news/$slug',getParentRoute: () => rootRouteImport
          })
const EsWhistleblowerSupportRoute = EsWhistleblowerSupportRouteImport.update({
            id: '/es/whistleblower-support',path: '/es/whistleblower-support',getParentRoute: () => rootRouteImport
          })
const EventsIndexRoute = EventsIndexRouteImport.update({
            id: '/events/',path: '/events/',getParentRoute: () => rootRouteImport
          })
const EventsChaptersRoute = EventsChaptersRouteImport.update({
            id: '/events/chapters',path: '/events/chapters',getParentRoute: () => rootRouteImport
          })
const NewsIndexRoute = NewsIndexRouteImport.update({
            id: '/news/',path: '/news/',getParentRoute: () => rootRouteImport
          })
const NewsTypeRoute = NewsTypeRouteImport.update({
            id: '/news/$type',path: '/news/$type',getParentRoute: () => rootRouteImport
          })
const EventsPageIdIndexRoute = EventsPageIdIndexRouteImport.update({
            id: '/events/$pageId/',path: '/events/$pageId/',getParentRoute: () => rootRouteImport
          })
const EventsPageIdEventIdRoute = EventsPageIdEventIdRouteImport.update({
            id: '/events/$pageId/$eventId',path: '/events/$pageId/$eventId',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutUsRoute: AboutUsRoute,AccountRoute: AccountRoute,AnimalcareRoute: AnimalcareRoute,ChaptersRoute: ChaptersRoute,ContactUsRoute: ContactUsRoute,CoreValuesRoute: CoreValuesRoute,DonateRoute: DonateRoute,EmployerDonationMatchingRoute: EmployerDonationMatchingRoute,NewChapterRoute: NewChapterRoute,OpenRescueRoute: OpenRescueRoute,PayrollGivingRoute: PayrollGivingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ResourcesRoute: ResourcesRoute,TakeActionRoute: TakeActionRoute,TermsOfServiceRoute: TermsOfServiceRoute,ThankYouRoute: ThankYouRoute,VeganismRoute: VeganismRoute,WhistleblowerSupportRoute: WhistleblowerSupportRoute,BlogSlugRoute: BlogSlugRoute,CampaignsSlugRoute: CampaignsSlugRoute,DxeInTheNewsSlugRoute: DxeInTheNewsSlugRoute,EsWhistleblowerSupportRoute: EsWhistleblowerSupportRoute,EventsChaptersRoute: EventsChaptersRoute,NewsTypeRoute: NewsTypeRoute,CampaignsIndexRoute: CampaignsIndexRoute,EventsIndexRoute: EventsIndexRoute,NewsIndexRoute: NewsIndexRoute,EventsPageIdEventIdRoute: EventsPageIdEventIdRoute,EventsPageIdIndexRoute: EventsPageIdIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)